<!-- 新增或修改 -->
<template>
  <Dialog
    :title="title"
    :modelValue="modelValue"
    :appendToBody="appendToBody"
    @onClosed="handleClosed"
    @onConfirm="handleAddUpdate"
  >
    <template #content>
      <el-form ref="productFormRef" :model="productFormData" label-width="82px" :rules="productRules">
        <el-form-item label="产品名称" prop="productName">
          <el-input
            v-model="productFormData.productName"
            placeholder="请输入产品名称"
          />
        </el-form-item>
        <el-form-item label="产品类型" prop="productType">
          <el-select
            v-model="productFormData.productType"
            filterable
            clearable
            placeholder="请选择产品类型"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('productType')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="使用类型" prop="usageType">
          <el-select
            v-model="productFormData.usageType"
            filterable
            clearable
            placeholder="请选择使用类型"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('usageType')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品规格">
          <el-input
            v-model="productFormData.classification"
            placeholder="请输入产品规格"
          />
        </el-form-item>
        <el-form-item label="供应商" prop="supplier">
          <el-select
            v-model="productFormData.supplier"
            filterable
            clearable
            placeholder="请选择供应商"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('supplier')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商型号" prop="supplierModel">
          <el-input
            v-model="productFormData.supplierModel"
            placeholder="请输入供应商型号"
          />
        </el-form-item>
        <el-form-item label="内部型号" prop="internalModel">
          <el-select
            v-model="productFormData.internalModel"
            filterable
            clearable
            placeholder="请选择内部型号"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('internalModel')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品照片">
          <ImageUpload  :image-addr="productFormData.imageUrl"  @on-success="logoUploadSuccess" />
        </el-form-item>
      </el-form>
    </template>
  </Dialog>
</template>

<script setup>
import ImageUpload from "@/components/Element/upload";
import Dialog from "@/components/Element/Dialog";
import { ref, onMounted, watch } from "vue";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";
import { addProduct, updateProduct } from "@/api/warehouse/product";

const cacheStore = useCacheStore(); // 缓存store
const { getDictListByParentCode } = cacheStore;

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "新增",
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  appendToBody: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:modelValue", "success"]);

const handleClosed = () => {
  emits("update:modelValue", false);
};
const logoUploadSuccess = addr => {
  productFormData.value.imageUrl = addr
}
const productFormData = ref({});
const productFormRef = ref(null);
const productRules = ref({
  productName: [
    {
      required: true,  // 必填
      trigger: 'blur',
      message: '产品名称为必填项'
    }
  ],
  classification: [
    {
      required: true,
      trigger: 'blur',
      message: '产品规格为必填项' // 验证规则
    }
  ],
  productType: [
    {
      required: true,
      trigger: 'blur',
      message: '产品类型为必填项' // 验证规则
    }
  ],
  usageType: [
    {
      required: true,
      trigger: 'blur',
      message: '使用类型为必填项' // 验证规则
    }
  ],
})
const handleAddUpdate = () => {
  productFormRef.value.validate((valid) => {
    if (!valid) return;
    // 新增
    if (isNull(productFormData.value?.productId)) {
      addProduct(productFormData.value)
        .then((res) => {
          handleClosed();
          emits("success", productFormData.value);
        })
        .catch((res) => {});
    } else {
      // 修改
      updateProduct(productFormData.value)
        .then((res) => {
          handleClosed();
          emits("success", productFormData.value);
        })
        .catch((res) => {});
    }
  });
};

onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      if (isNull(newVal)) {
        productFormData.value = {};
      } else {
        productFormData.value = { ...newVal };
      }
    }
  );
});
</script>

<style lang="scss" scoped></style>
